import React from "react"
import { StrapiPlansSelector } from "components/PlansSelector/StrapiPlansSelector"
import { HeaderOptions } from "components/Header/HeaderUI"
import BigIconsHero from "../BigIconsHero"
import BooksHero from "../BooksHero"
import CTAStrip from "../CTAStrip"
import EngagingBanner from "../EngagingBanner"
import ExplanationHero from "../ExplanationHero"
import FAQSection from "../FAQSection"
import FixedBanner from "../FixedBanner"
import HowItWorks from "../HowItWorks"
import PageTitle from "../PageTitle"
import ParentsHero from "../ParentsHero"
import Partners from "../Partners" // White bg
import PartnersGroup from "../PartnersHero" // Homepage style
import QuoteHero from "../QuoteHero"
import QuotesCarousel from "../QuotesCarousel"
import RatingsHero from "../RatingsHero"
import RichSection from "../RichSection"
import ShopHero from "../ShopHero"
import StrapiPlanHero from "../StrapiPlanHero"
import StrapiPlansSection from "../StrapiPlansSection"
import TeacherCTAHero from "../TeacherCTAHero"
import TeachersHero from "../TeachersHero"
import TitleSeparator from "../TitleSeparator"
import ZooHero from "../ZooHero"
import { TrustpilotWidgetBase } from "../../TrustpilotWidgets"
import LandingPageHero from "../LandingPageHero"

export const STRAPI_TYPE_TO_TYPENAME = {
  "product.product-quote": "Strapi_ComponentProductProductQuote",
  "product.product-highlight": "Strapi_ComponentProductProductHighlight",
  "product.video": "Strapi_ComponentProductVideo",
  "product.product-cta": "Strapi_ComponentProductProductCta",
  "hero.partners-group": "Strapi_ComponentHeroPartnersGroup",
  "hero.books-hero": "Strapi_ComponentHeroBooksHero",
  "hero.teacher-hero": "Strapi_ComponentHeroTeacherHero",
  "hero.parent-product-hero": "Strapi_ComponentHeroParentProductHero",
  "hero.shop-hero": "Strapi_ComponentHeroShopHero",
  "hero.explanation-hero": "Strapi_ComponentHeroExplanationHero",
  "hero.ratings-hero": "Strapi_ComponentHeroRatingsHero",
  "hero.engaging-banner": "Strapi_ComponentHeroEngagingBanner",
  "hero.big-icons-hero": "Strapi_ComponentHeroBigIconsHero",
  "hero.how-it-works": "Strapi_ComponentHeroHowItWorks",
  "hero.quote-hero": "Strapi_ComponentHeroQuoteHero",
  "hero.plans-hero": "Strapi_ComponentHeroPlansHero",
  "hero.plan-hero": "Strapi_ComponentHeroPlanHero",
  "hero.quotes-carousel": "Strapi_ComponentHeroQuotesCarousel",
  "hero.teacher-cta-hero": "Strapi_ComponentHeroTeacherCtaHero",
  "layout.rich-section": "Strapi_ComponentLayoutRichSection",
  "hero-partners": "Strapi_ComponentHeroPartners",
  "layout.title-separator": "Strapi_ComponentLayoutTitleSeparator",
  "layout.page-title": "Strapi_ComponentLayoutPageTitle",
  "hero.faq-section": "Strapi_ComponentHeroFaqSection",
  "layout.fixed-banner": "Strapi_ComponentLayoutFixedBanner",
  "layout.cta-strip": "Strapi_ComponentLayoutCtaStrip",
  "widgets.trustpilot-widget": "Strapi_ComponentWidgetsTrustpilotWidget",
  "hero.landing-page-hero": "Strapi_ComponentHeroLandingPageHero",
}

export const INTERNAL_TYPE_TO_STRAPI = {
  ComponentProductProductQuote: "Strapi_ComponentProductProductQuote",
  ComponentProductProductHighlight: "Strapi_ComponentProductProductHighlight",
  ComponentProductVideo: "Strapi_ComponentProductVideo",
  ComponentProductProductCta: "Strapi_ComponentProductProductCta",
  ComponentHeroPartnersGroup: "Strapi_ComponentHeroPartnersGroup",
  ComponentHeroBooksHero: "Strapi_ComponentHeroBooksHero",
  ComponentHeroTeacherHero: "Strapi_ComponentHeroTeacherHero",
  ComponentHeroParentProductHero: "Strapi_ComponentHeroParentProductHero",
  ComponentHeroShopHero: "Strapi_ComponentHeroShopHero",
  ComponentHeroExplanationHero: "Strapi_ComponentHeroExplanationHero",
  ComponentHeroRatingsHero: "Strapi_ComponentHeroRatingsHero",
  ComponentHeroEngagingBanner: "Strapi_ComponentHeroEngagingBanner",
  ComponentHeroBigIconsHero: "Strapi_ComponentHeroBigIconsHero",
  ComponentHeroHowItWorks: "Strapi_ComponentHeroHowItWorks",
  ComponentHeroQuoteHero: "Strapi_ComponentHeroQuoteHero",
  ComponentHeroPlansHero: "Strapi_ComponentHeroPlansHero",
  ComponentHeroPlanHero: "Strapi_ComponentHeroPlanHero",
  ComponentHeroQuotesCarousel: "Strapi_ComponentHeroQuotesCarousel",
  ComponentHeroTeacherCtaHero: "Strapi_ComponentHeroTeacherCtaHero",
  ComponentLayoutRichSection: "Strapi_ComponentLayoutRichSection",
  ComponentHeroPartners: "Strapi_ComponentHeroPartners",
  ComponentLayoutTitleSeparator: "Strapi_ComponentLayoutTitleSeparator",
  ComponentLayoutPageTitle: "Strapi_ComponentLayoutPageTitle",
  ComponentHeroFaqSection: "Strapi_ComponentHeroFaqSection",
  ComponentLayoutFixedBanner: "Strapi_ComponentLayoutFixedBanner",
  ComponentLayoutCtaStrip: "Strapi_ComponentLayoutCtaStrip",
  ComponentWidgetsTrustpilotWidget: "Strapi_ComponentWidgetsTrustpilotWidget",
  ComponentHeroPlansSelector: "Strapi_ComponentHeroPlansSelector",
  ComponentHeroLandingPageHero: "Strapi_ComponentHeroLandingPageHero",
}

export const STRAPI_COMPONENTS = {
  Strapi_ComponentHeroZooHero: ZooHero,
  Strapi_ComponentHeroShopHero: ShopHero,
  Strapi_ComponentHeroBooksHero: BooksHero,
  Strapi_ComponentHeroPartnersGroup: PartnersGroup,
  Strapi_ComponentHeroParentProductHero: ParentsHero,
  Strapi_ComponentHeroTeacherHero: TeachersHero,
  Strapi_ComponentHeroExplanationHero: ExplanationHero,
  Strapi_ComponentLayoutTitleSeparator: TitleSeparator,
  Strapi_ComponentHeroEngagingBanner: EngagingBanner,
  Strapi_ComponentHeroBigIconsHero: BigIconsHero,
  Strapi_ComponentHeroRatingsHero: RatingsHero,
  Strapi_ComponentHeroHowItWorks: HowItWorks,
  Strapi_ComponentHeroQuoteHero: QuoteHero,
  Strapi_ComponentHeroPlansHero: StrapiPlansSection,
  Strapi_ComponentHeroPlanHero: StrapiPlanHero,
  Strapi_ComponentHeroQuotesCarousel: QuotesCarousel,
  Strapi_ComponentHeroTeacherCtaHero: TeacherCTAHero,
  Strapi_ComponentLayoutPageTitle: PageTitle,
  Strapi_ComponentHeroFaqSection: FAQSection,
  Strapi_ComponentHeroPartners: Partners,
  Strapi_ComponentLayoutRichSection: RichSection,
  Strapi_ComponentLayoutFixedBanner: FixedBanner,
  Strapi_ComponentLayoutCtaStrip: CTAStrip,
  Strapi_ComponentWidgetsTrustpilotWidget: TrustpilotWidgetBase,
  Strapi_ComponentHeroPlansSelector: StrapiPlansSelector,
  Strapi_ComponentHeroLandingPageHero: LandingPageHero,
}

export const STRAPI_PROPS_TO_LOCALPROPS = {
  Strapi_ComponentHeroZooHero: props => props,
  Strapi_ComponentHeroShopHero: props => props,
  Strapi_ComponentHeroBooksHero: props => props,
  Strapi_ComponentHeroPartnersGroup: props => props,
  Strapi_ComponentHeroParentProductHero: props => props,
  Strapi_ComponentHeroTeacherHero: props => props,
  Strapi_ComponentHeroExplanationHero: props => props,
  Strapi_ComponentLayoutTitleSeparator: props => props,
  Strapi_ComponentHeroEngagingBanner: props => ({
    backgroundImage: props.backgroundImage,
    image: props.image,
    title: props.title,
    slug: props.slug,
    points: {
      icon:
        props.BulletPoint &&
        props.BulletPoint[0] &&
        props.BulletPoint[0].bulletIcon,
      texts: props.BulletPoint.map(b => b.value),
    },
    buttons: props.buttons,
  }),
  Strapi_ComponentHeroBigIconsHero: props => props,
  Strapi_ComponentHeroRatingsHero: props => ({
    starsImage: props.starsImage,
    quotes: props.quotes.map(q => ({
      text: q.value,
      author: {
        name: q.authorName,
        title: q.authorTitle,
      },
    })),
  }),
  Strapi_ComponentHeroHowItWorks: props => ({
    title: props.title,
    thumbnail: props.thumbnail,
    videoUrl: props.video && props.video.url,
    elements: props.HowItWorksElement.map(e => e),
  }),
  Strapi_ComponentHeroQuoteHero: props => ({
    title: props.title,
    text: props.text,
    image: props.image,
    author: {
      name: props.authorName,
    },
  }),
  Strapi_ComponentHeroPlansHero: props => props,
  Strapi_ComponentHeroPlanHero: props => props,
  Strapi_ComponentHeroQuotesCarousel: props => props,
  Strapi_ComponentHeroTeacherCtaHero: props => props,
  Strapi_ComponentLayoutPageTitle: props => props,
  Strapi_ComponentHeroFaqSection: props => props,
  Strapi_ComponentHeroPartners: (props, pageContext?: {
    defaultLang: string
    slug: string
    pagePath?: string
    headerOptions?: HeaderOptions
  }) => {
    if (pageContext?.pagePath === '/parents/checkout/plan') {
      return {
        ...props,
        hiddenMobile: true
      }
    }
    return props
  },
  Strapi_ComponentLayoutRichSection: props => props,
  Strapi_ComponentLayoutFixedBanner: props => props,
  Strapi_ComponentLayoutCtaStrip: props => props,
  Strapi_ComponentWidgetsTrustpilotWidget: props => props,
  Strapi_ComponentHeroPlansSelector: props => props,
  Strapi_ComponentHeroLandingPageHero: props => props,
}

interface IProps {
  content: any[]
  pageContext?: {
    defaultLang: string
    slug: string
    pagePath?: string
    headerOptions?: HeaderOptions
  }
}

const DynamicZone = (props: IProps) => {
  const components = props.content
    .map(c => {
      const component =
        STRAPI_COMPONENTS[
          INTERNAL_TYPE_TO_STRAPI[c.__typename] ||
            c.__typename ||
            STRAPI_TYPE_TO_TYPENAME[c.strapi_component]
        ]
      const transformProps =
        STRAPI_PROPS_TO_LOCALPROPS[
          INTERNAL_TYPE_TO_STRAPI[c.__typename] ||
            c.__typename ||
            STRAPI_TYPE_TO_TYPENAME[c.strapi_component]
        ] || (props => props)
      if (component)
        return React.createElement(component, {
          key: `${
            INTERNAL_TYPE_TO_STRAPI[c.__typename] ||
            c.__typename ||
            STRAPI_TYPE_TO_TYPENAME[c.strapi_component]
          }-${c.id}`,
          ...transformProps(c, props.pageContext),
        })
      return null
    })
    .filter(c => c)

  return <>{components}</>
}

export default DynamicZone
